export const DashboardQiuckButton = {
	basicBtn: [
		{
			title: '产品信息',
			description: '查看系统中全部产品',
			imageKey: 'products',
			link: '/productlist',
		},
	],
	managerBtn: [
		{
			title: '新建订单',
			description: '进入建单流程并提交订单',
			imageKey: 'create',
			link: '/order/create/new',
		},
		{
			title: '订单编辑',
			description: '未完成的订单草稿',
			imageKey: 'edit',
			link: '/editlist',
		},
		{
			title: '报价查询',
			description: '新建报价或查看历史快照',
			imageKey: 'quotation',
			link: '/quotationlist',
		},
		{
			title: '订单查询',
			description: '跟进订单进度并完成修改状态',
			imageKey: 'orderList',
			link: '/orderlist',
		},
		{
			title: '绩效管理',
			description: '绩效规则配置与批量重匹配',
			imageKey: 'performance',
			link: '/manager/performancerules',
			requiresRulesManagement: true,
		},
		{
			title: '客户信息',
			description: '查看或添加客户信息',
			imageKey: 'customers',
			link: '/customerlist',
		},
		{
			title: '业务统计',
			description: '经营总览、制作图表与图表库',
			imageKey: 'statistics',
			link: '/statistics',
		},
		{
			title: '审批信息',
			description: '查看申请进度，并处理订单、客户等审批',
			imageKey: 'approval',
			link: '/approval/list',
		},
	],
	financeBtn: [
		{
			title: '订单查询',
			description: '跟进订单进度并完成修改状态',
			imageKey: 'orderList',
			link: '/orderlist',
		},
		{
			title: '客户信息',
			description: '查看或添加客户信息',
			imageKey: 'customers',
			link: '/customerlist',
		},
		{
			title: '审批信息',
			description: '查看申请进度与驳回记录',
			imageKey: 'approval',
			link: '/approval/list',
		},
		{
			title: '业务统计',
			description: '经营总览、制作图表与图表库',
			imageKey: 'statistics',
			link: '/statistics',
		},
	],
	buyerBtn: [
		{
			title: '订单查询',
			description: '跟进订单进度并完成修改状态',
			imageKey: 'orderList',
			link: '/orderlist',
		},
		{
			title: '客户信息',
			description: '查看或添加客户信息',
			imageKey: 'customers',
			link: '/customerlist',
		},
		{
			title: '审批信息',
			description: '查看申请进度与驳回记录',
			imageKey: 'approval',
			link: '/approval/list',
		},
	],
	userBtn: [
		{
			title: '新建订单',
			description: '进入建单流程并提交订单',
			imageKey: 'create',
			link: '/order/create/new',
		},
		{
			title: '订单编辑',
			description: '未完成的订单草稿',
			imageKey: 'edit',
			link: '/editlist',
		},
		{
			title: '报价查询',
			description: '新建报价或查看历史快照',
			imageKey: 'quotation',
			link: '/quotationlist',
		},
		{
			title: '订单查询',
			description: '跟进订单进度并完成修改状态',
			imageKey: 'orderList',
			link: '/user/orderlist',
		},
		{
			title: '客户信息',
			description: '管理客户及分配销售员',
			imageKey: 'customers',
			link: '/customerlist',
		},
		{
			title: '审批信息',
			description: '查看申请进度与驳回记录',
			imageKey: 'approval',
			link: '/approval/list',
		},
	],
	assistantBtn: [
		{
			title: '新建订单',
			description: '代销售员新建并提交订单',
			imageKey: 'create',
			link: '/order/create/new',
		},
		{
			title: '订单编辑',
			description: '未完成的订单草稿',
			imageKey: 'edit',
			link: '/editlist',
		},
		{
			title: '报价查询',
			description: '新建报价或查看历史快照',
			imageKey: 'quotation',
			link: '/quotationlist',
		},
		{
			title: '订单查询',
			description: '跟进订单进度并完成修改状态',
			imageKey: 'orderList',
			link: '/orderlist',
		},
		{
			title: '客户信息',
			description: '查看或添加客户信息',
			imageKey: 'customers',
			link: '/customerlist',
		},
		{
			title: '审批信息',
			description: '查看申请进度与驳回记录',
			imageKey: 'approval',
			link: '/approval/list',
		},
		{
			title: '业务统计',
			description: '查看您协作范围内的订单统计',
			imageKey: 'statistics',
			link: '/statistics',
		},
	],
	saleBtn: [
		{
			title: '新建订单',
			description: '进入建单流程并提交订单',
			imageKey: 'create',
			link: '/order/create/new',
		},
		{
			title: '订单编辑',
			description: '未完成的订单草稿',
			imageKey: 'edit',
			link: '/editlist',
		},
		{
			title: '报价查询',
			description: '新建报价或查看历史快照',
			imageKey: 'quotation',
			link: '/quotationlist',
		},
		{
			title: '订单查询',
			description: '跟进订单进度并完成修改状态',
			imageKey: 'orderList',
			link: '/orderlist',
		},
		{
			title: '客户信息',
			description: '帮助销售员维护客户信息',
			imageKey: 'customers',
			link: '/customerlist',
		},
		{
			title: '审批信息',
			description: '查看申请进度与驳回记录',
			imageKey: 'approval',
			link: '/approval/list',
		},
		{
			title: '业务统计',
			description: '经营总览、制作图表与图表库',
			imageKey: 'statistics',
			link: '/statistics',
		},
	],
	adminBtn: [
		{
			title: '新建订单',
			description: '进入建单流程并提交订单',
			imageKey: 'create',
			link: '/order/create/new',
		},
		{
			title: '订单编辑',
			description: '未完成的订单草稿',
			imageKey: 'edit',
			link: '/editlist',
		},
		{
			title: '报价查询',
			description: '新建报价或查看历史快照',
			imageKey: 'quotation',
			link: '/quotationlist',
		},
		{
			title: '订单查询',
			description: '跟进订单进度并完成修改状态',
			imageKey: 'orderList',
			link: '/orderlist',
		},
		{
			title: '审批信息',
			description: '查看申请进度，并处理订单、客户等审批',
			imageKey: 'approval',
			link: '/approval/list',
		},
		{
			title: '绩效管理',
			description: '绩效规则配置与批量重匹配',
			imageKey: 'performance',
			link: '/manager/performancerules',
			requiresRulesManagement: true,
		},
		{
			title: '业务统计',
			description: '经营总览、制作图表与图表库',
			imageKey: 'statistics',
			link: '/statistics',
		},
		{
			title: '客户信息',
			description: '查看系统中全部客户',
			imageKey: 'customers',
			link: '/customerlist',
		},
		{
			title: '产品信息',
			description: '查看系统中全部产品',
			imageKey: 'products',
			link: '/productlist',
		},
		{
			title: '系统用户管理',
			description: '系统账号与权限',
			imageKey: 'users',
			link: '/userlist',
			requiresPermission: 'erp.menu.user.list',
		},
		{
			title: '角色权限模板',
			description: '各角色默认可分配权限点',
			imageKey: 'roleTemplate',
			link: '/admin/role-permissions',
			requiresPermission: 'erp.user.update',
		},
		{
			title: '登录日志',
			description: '系统用户登录成功与失败记录',
			imageKey: 'loginLogs',
			link: '/admin/loginlogs',
			requiresPermission: 'erp.menu.loginlog.list',
		},
	],
};

/** 权限治理入口：按权限点挂到按钮岛（不依赖角色字符串） */
export const PERMISSION_GOVERNANCE_QUICK_LINKS = [
	{
		title: '系统用户管理',
		description: '系统账号与权限',
		imageKey: 'users',
		link: '/userlist',
		requiresPermission: 'erp.menu.user.list',
	},
	{
		title: '角色权限模板',
		description: '各角色默认可分配权限点',
		imageKey: 'roleTemplate',
		link: '/admin/role-permissions',
		requiresPermission: 'erp.user.update',
	},
	{
		title: '登录日志',
		description: '系统用户登录成功与失败记录',
		imageKey: 'loginLogs',
		link: '/admin/loginlogs',
		requiresPermission: 'erp.menu.loginlog.list',
	},
];

